import { authenticationService } from "../_services/authentication.service";

export function authHeader() {
  const currentUser = authenticationService.currentUserValue;
  if (currentUser && currentUser.token) {
    return {
      Authorization: `Bearer ${currentUser.token}`,
      "Content-Type": "application/json",
    };
  } else {
    return {};
  }
}
export function authHeaderWithOutToken() {
  return { "Content-Type": "application/json" };
}

export function authHeaderAcceptWithJson() {
  const currentUser = authenticationService.currentUserValue;
  if (currentUser && currentUser.token) {
    return {
      Authorization: `Bearer ${currentUser.token}`,
      Accept: "application/json",
    };
  } else {
    return {};
  }
}
